import { useEffect, useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api from "../../config/axiosConfig";
import { toast } from "react-toastify";

const ConfirmarCuenta = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState(null);

  useEffect(() => {
    const confirmar = async () => {
      const tokenParam = searchParams.get("token");
      if (!tokenParam) {
        toast.error("Token no válido.");
        return;
      }
      setToken(tokenParam);

      try {
        await api.post("/auth/confirmar-cuenta", { tokenParam });
        toast.success("Cuenta confirmada, redirigiendo...");
        setTimeout(() => navigate("/login"), 2000);
      } catch (error) {
        console.error(error);
        toast.error("Token inválido o expirado.");
      }
    };

    confirmar();
  }, [searchParams, navigate]);

  const handleConfirmarCuenta = async (event) => {
    event.preventDefault();

    if (!token) {
      toast.error("Token no válido.");
      return;
    }

    try {
      await api.post("/auth/confirmar-cuenta", { token });
      toast.success("Cuenta confirmada, redirigiendo...");
      setTimeout(() => navigate("/login"), 2000);
    } catch (error) {
      console.error(error);
      toast.error("Token inválido o expirado.");
    }
  };

  const handleChange = (e) => {
    setToken(e.target.value);
  };

  return (
    <div className="login login-v2 fw-bold">
      <div className="login-cover">
        <div
          className="login-cover-img"
          style={{
            backgroundImage: `url(/assets/img/login-bg/login-bg-17.jpg)`,
          }}
        ></div>
        <div className="login-cover-bg"></div>
      </div>

      <div className="login-container">
        <div className="login-header">
          <div className="brand">
            <div className="d-flex align-items-center">
              <span className="logo"></span> <b>Mambo</b> Admin
            </div>
            <small>Sistema de control de facturacion</small>
          </div>
          <div className="icon">
            <i className="fa fa-lock"></i>
          </div>
        </div>

        <div className="login-content">
          <form onSubmit={handleConfirmarCuenta}>
            <div className="form-floating mb-20px">
              <input
                type="text"
                name="token"
                className="form-control fs-13px h-45px border-0"
                placeholder="Token para confirmar cuenta"
                value={token}
                onChange={handleChange}
              />
              <label className="d-flex align-items-center text-gray-600 fs-13px">Ingresar token para confirmar cuenta</label>
            </div>

            <div className="mb-20px">
              <button type="submit" className="btn btn-theme d-block w-100 h-45px btn-lg">
                Confirmar Cuenta
              </button>
            </div>
            <div className="text-gray-500">
              Ya eres miembro activo? Click <Link to="/login">aqui</Link> para iniciar sesion.
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ConfirmarCuenta;
